import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import logo from '../images/logo_white.webp';
import ScrollToTop from './ScrollToTop';
import './Layout.css';

const Layout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Empêcher le scroll de l'arrière-plan quand le menu est ouvert
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Nettoyer l'effet au démontage du composant
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="layout">
      <ScrollToTop />
      <header className="header">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo" onClick={closeMenu}>
              <img src={logo} alt="Vie et couleurs" className="nav-logo-img" />
            </Link>
            <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <li className="nav-item">
                <Link 
                  to="/" 
                  className={`nav-link ${isActive('/') ? 'active' : ''}`} 
                  onClick={closeMenu}
                >
                  Accueil
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/couverture" 
                  className={`nav-link ${isActive('/couverture') ? 'active' : ''}`} 
                  onClick={closeMenu}
                >
                  Couverture
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/peinture-interieure" 
                  className={`nav-link ${isActive('/peinture-interieure') ? 'active' : ''}`} 
                  onClick={closeMenu}
                >
                   Peinture
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/ravalement" 
                  className={`nav-link ${isActive('/ravalement') ? 'active' : ''}`} 
                  onClick={closeMenu}
                >
                  Ravalement de façade
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/contact" 
                  className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Contact
                </Link>
              </li>
            </ul>
            <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
          </div>
        </nav>
      </header>

      <main className="main-content">
        <Outlet />
      </main>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section footer-brand">
            <img src={logo} alt="Vie et couleurs" className="footer-logo" />
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/couverture" className="link-plain">Couverture</Link></li>
                <li><Link to="/peinture-interieure" className="link-plain">Peinture</Link></li>
              <li><Link to="/ravalement" className="link-plain">Ravalement de façade</Link></li>
              <li><Link to="/contact" className="link-plain">Contact et devis</Link></li>
            </ul>
          </div>
          <div className="footer-section footer-contact">
            <h4>Contact</h4>
            <p>📞 <a href="tel:0766059863" className="link-plain">07 66 05 98 63</a></p>
            <p>✉️ <a href="mailto:senane.yassine44@gmail.com" className="link-plain">senane.yassine44@gmail.com</a></p>
            <p>📍 Couëron - Région nantaise</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Nokram. Tous droits réservés.
            {' '}•{' '}
            <Link to="/mentions-legales" className="link-plain">Mentions légales</Link>
            {' '}•{' '}
            <Link to="/politique-de-confidentialite" className="link-plain">Politique de confidentialité</Link>
            {' '}•{' '}
            <Link to="/cgu" className="link-plain">CGU</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;

